import { render } from "./pagination.vue?vue&type=template&id=2ac3a9c0"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/public/pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ac3a9c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ac3a9c0', __exports__)) {
    console.log('reload')
    api.reload('2ac3a9c0', __exports__)
  }
  
  module.hot.accept("./pagination.vue?vue&type=template&id=2ac3a9c0", () => {
    console.log('re-render')
    api.rerender('2ac3a9c0', render)
  })

}


export default __exports__